// Libs
import { Icon as ChakraIcon } from '@chakra-ui/react'

// Icons
import { MdVisibility, MdVisibilityOff, MdLogout, MdAdd, MdSettings, MdDarkMode, MdLightMode, MdSearch, MdError, MdRefresh, MdSend, MdClose, MdEdit, MdBusiness, MdOutlinePassword, MdDelete, MdBlock, MdSupportAgent, MdMoreHoriz, MdCancel, MdPlayCircle, MdAttachFile, MdFileDownload, MdInfo, MdCheckCircle, MdAddCircle, MdComment, MdDiamond, MdNotifications, MdOutlineReceipt, MdPrint, MdHome, MdMenu, MdReceiptLong, MdWarningAmber } from 'react-icons/md'
import { TbProgressBolt, TbFileTypeXml, TbStatusChange } from 'react-icons/tb'
import { RxReader } from 'react-icons/rx'
import {
    FaShoppingBag, FaUserAlt, FaMap, FaBold, FaExternalLinkAlt, FaTruck, FaUsers, FaUserTie, FaWarehouse, FaTools,
    FaRegCalendarPlus
} from 'react-icons/fa'
import { FaMoneyCheckDollar, FaCartShopping } from "react-icons/fa6"
import { BiSolidPackage, BiShieldQuarter, BiPackage, BiTransfer } from 'react-icons/bi'
import { VscJson } from 'react-icons/vsc'
import { LuPackage } from 'react-icons/lu'
import {GoArrowLeft, GoArrowRight, GoPlug} from 'react-icons/go'
import { BsShieldCheck } from 'react-icons/bs'
import { FiDownload, FiUpload } from 'react-icons/fi'
import { PiFileTxt, PiFileCsv, PiFileHtml, PiFilePdf, PiFilePng, PiFileJpg, PiFileDoc, PiPlugsBold, PiPlugsConnectedBold } from 'react-icons/pi'
import { GiWeight } from 'react-icons/gi'
import { DiGoogleAnalytics } from "react-icons/di"
import { CiBank } from "react-icons/ci"

export default function Icon({ name, ...props }){
    
    let icon;

    switch(name){
        case 'left': icon = GoArrowLeft; break;
        case 'right': icon = GoArrowRight; break;
        case 'visible': case 'view': icon = MdVisibility; break;
        case 'hidden': icon = MdVisibilityOff; break;
        case 'external': icon = FaExternalLinkAlt; break;
        case 'logout': icon = MdLogout; break;
        case 'settings': icon = MdSettings; break;
        case 'add': case 'new': icon = MdAdd; break;
        case 'addcircle': icon = MdAddCircle; break;
        case 'product': case 'products': icon = FaShoppingBag; break;
        case 'dark': icon = MdDarkMode; break;
        case 'light': icon = MdLightMode; break;
        case 'search': icon = MdSearch; break;
        case 'error': icon = MdError; break;
        case 'password': icon = MdOutlinePassword; break;
        case 'refresh': icon = MdRefresh; break;
        case 'send': icon = MdSend; break;
        case 'business': icon = MdBusiness; break;
        case 'close': case 'cancel': icon = MdClose; break;
        case 'edit': icon = MdEdit; break;
        case 'bank': icon = CiBank; break;
        case 'roles': icon = BiShieldQuarter; break;
        case 'trash': icon = MdDelete; break;
        case 'block': icon = MdBlock; break;
        case 'distributor': icon = LuPackage; break;
        case 'diamond': icon = MdDiamond; break;
        case 'identity': icon = BsShieldCheck; break;
        case 'progress': icon = TbProgressBolt; break;
        case 'check': icon = MdCheckCircle; break;
        case 'close_ticket': icon = MdCancel; break;
        case 'more': icon = MdMoreHoriz; break;
        case 'ticket': icon = MdSupportAgent; break;
        case 'tools': icon = FaTools; break;
        case 'info': icon = MdInfo; break;
        case 'file': icon = MdFileDownload; break;
        case 'map': icon = FaMap; break;
        case 'pdf': icon = PiFilePdf; break;
        case 'png': icon = PiFilePng; break;
        case 'jpg': icon = PiFileJpg; break;
        case 'txt': icon = PiFileTxt; break;
        case 'csv': icon = PiFileCsv; break;
        case 'xml': icon = TbFileTypeXml; break;
        case 'doc': case 'docx': icon = PiFileDoc; break;
        case 'html': icon = PiFileHtml; break;
        case 'bling': icon = FaBold; break;
        case 'download': icon = FiDownload; break;
        case 'upload': icon = FiUpload; break;
        case 'notification': icon = MdNotifications; break;
        case 'comment': icon = MdComment; break;
        case 'json': case 'dev': icon = VscJson; break;
        case 'user': case 'users': icon = FaUserAlt; break;
        case 'attachment': case 'file': icon = MdAttachFile; break;
        case 'play': case 'in_progress': icon = MdPlayCircle; break;
        case 'movement': case 'transfer': icon = BiTransfer; break;
        case 'read': icon = RxReader; break;
        case 'package': icon = BiPackage; break;
        case 'quotation': icon = GiWeight; break;
        case 'transit': icon = FaTruck ; break;
        case 'fiscal': icon = MdOutlineReceipt; break;
        case 'consultants': case 'consultant': icon = FaUsers; break;
        case 'employees': case 'employee': icon = FaUserTie; break;
        case 'warehouse': case 'distributors': case 'distributor': icon = FaWarehouse; break;
        case 'financial': icon = FaMoneyCheckDollar; break;
        case 'reports': case 'report': icon = DiGoogleAnalytics; break;
        case 'order': case 'orders': icon = FaCartShopping; break;
        case 'print': icon = MdPrint; break;
        case 'status': icon = TbStatusChange; break;
        case 'pending': icon = FaRegCalendarPlus; break;
        case 'home': icon = MdHome; break;
        case 'menu': icon = MdMenu; break;
        case 'plug': icon = GoPlug; break;
        case 'plugs-bold': icon = PiPlugsBold; break;
        case 'plugs-connected-bold': icon = PiPlugsConnectedBold; break;

        // Estoque / NF-e
        case 'invoice': case 'invoices': icon = MdReceiptLong; break;
        case 'movements': icon = BiTransfer; break;
        case 'loss': case 'losses': icon = MdWarningAmber; break;
        case 'traceability': icon = FaMap; break;

        // Expedition
        case 'stock': case 'package': icon = BiSolidPackage; break;

        default: icon = MdVisibility; break;
    }

    return <ChakraIcon as={icon} {...props} />
}